import { deleteRequest } from '@/core';
import { preferredVendors } from '@/requests';
export default async function deletePreferredVendorRequest(idToDelete) {
	let url = preferredVendors.getByIdPath(idToDelete);
	return deleteRequest(url);
}